var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.url)?_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.url}},[_vm._v("Open in checkout")]):_c('a',{staticClass:"btn btn-primary disabled",attrs:{"disabled":""}},[_vm._v("Open in checkout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }